<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>

<div class="dash">
  <!-- 📊 Top Summary Cards -->
  <div class="summary-cards">
    <div class="card">
      <h3>Total Invoices</h3>
      <p>124</p>
    </div>
    <div class="card">
      <h3>Paid</h3>
      <p>98</p>
    </div>
    <div class="card">
      <h3>Pending</h3>
      <p>18</p>
    </div>
    <div class="card">
      <h3>Cancelled</h3>
      <p>8</p>
    </div>
  </div>

  <!-- 🔍 Filter + Action Bar -->
  <div class="filter-bar">
    <div class="filters">
      <input type="text" placeholder="Search invoice, customer, or truck" />
      <select>
        <option value="">All Status</option>
        <option value="draft">Draft</option>
        <option value="paid">Paid</option>
        <option value="unpaid">Unpaid</option>
        <option value="cancelled">Cancelled</option>
      </select>
      <input type="date" placeholder="From" />
      <input type="date" placeholder="To" />
    </div>
    <div class="actions">
      <button class="btn-primary" (click)="openInvoiceDialog()">Create Invoice</button>
      <!-- <button class="btn-secondary">⟳ Sync from Zoho</button> -->
    </div>
  </div>

  <!-- 📋 Invoice List Table -->
  <div class="invoice-table">
    <table>
      <thead>
        <tr>
          <th>Invoice #</th>
          <th>Customer</th>
          <th>Date</th>
          <th>Due Date</th>
          <th>Amount</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let i of [1,2,3,4,5]">
          <td>INV-00{{ i }}</td>
          <td>ABC Logistics</td>
          <td>2025-10-30</td>
          <td>2025-11-05</td>
          <td>₹{{ i * 5000 }}</td>
          <td><span class="status paid">Paid</span></td>
          <td>
            <button class="view">
              <mat-icon>visibility</mat-icon>
            </button>
            <button class="edit" mat-icon-button>
              <mat-icon>download</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
